import React from 'react'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

function WageLabelModal({ closeModal }) {
	return (
		<div id='wage-label__modal' className='modal'>
			<div className='container'>
				<div className='row justify-content-center'>
					<div
						id='wage-label__window'
						className='col-md-7 align-self-center'>
						<div id='wage-label' className='pos-relative'>
							<FAI icon='times' size='2x' onClick={closeModal} />
							<div id='wage-label__header' className='flexbox'>
								<span className='col-md-6'>
									<h2 className='header__title'>
										Wage Label
									</h2>
								</span>
								<span className='col-md-6'>
									{/* spacer column */}
								</span>
							</div>
							<div id='wage-label__wages' className='flexbox'>
								<span className='col-md-6'>
									<h3 className='wage__title'>Lowest Wage</h3>
									<h4 className='wage__title'>
										Country&apos;s Min. Wage
									</h4>
								</span>
								<span className='col-md-6 text-right'>
									<h3 className='wage__number'>$13.25</h3>
									<h4 className='wage__number'>$8.75</h4>
								</span>
							</div>
							<div id='wage-label__labels' className='flexbox'>
								<span className='col-md-6'>
									<div className='pos-relative'>
										<h3 className='label__title'>
											Equality
										</h3>
										<span className='label__description'>
											Lorem ipsum dolor sit amet
											consectetur adipisicing elit.
											Delectus accusantium autem non
											nesciunt magni at quam adipisci enim
											eum maxime!
										</span>
									</div>
									<div className='pos-relative'>
										<h3 className='label__title'>Safety</h3>
										<span className='label__description'>
											Lorem ipsum dolor sit amet
											consectetur adipisicing elit.
											Delectus accusantium autem non
											nesciunt magni at quam adipisci enim
											eum maxime!
										</span>
									</div>
									<div className='pos-relative'>
										<h3 className='label__title'>Wages</h3>
										<span className='label__description'>
											Lorem ipsum dolor sit amet
											consectetur adipisicing elit.
											Delectus accusantium autem non
											nesciunt magni at quam adipisci enim
											eum maxime!
										</span>
									</div>
								</span>
								<span className='col-md-6 text-right'>
									<h3 className='label__rank '>Medium</h3>
									<h3 className='label__rank '>High</h3>
									<h3 className='label__rank '>High</h3>
								</span>
							</div>
							<div id='wage-label__copy' className='flexbox'>
								<div className='col-12'>
									<p>
										This maker meets The Etho's
										sustainability and ethical standards.
										the Etho collates this information via
										on-site audits, employee interviews and
										verified company documents.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default WageLabelModal
